<div *ngIf="loader; else content" class="height-100 d-flex flex-direction-column justify-content-center align-items-center row-gap">
    <span class="text-danger">It will take some time to load a large file...</span>
    <ds-loading-dots size="lg" color="#a82b41"></ds-loading-dots>
</div>

<ng-template #content>
    <iframe *ngIf="url" height="100%" type="application/pdf" width="100%" [src]="url"></iframe>
</ng-template>
